import { history } from "../constants/History";

const redirect = (url: string, callbackUrl?: string): void => {
  if (url.startsWith("http")) {
    window.open(url, "_blank");
    callbackUrl && history.push(callbackUrl);
  } else {
    history.push(url);
  }
}

export const navService = {
  redirect,
}
